import { track } from './mixpanel';

/**
 * Track when a user adds a product to cart DONE
 */
export function trackAddToCart(product) {
  track('add_to_cart', {
    product_id: product?.productID,
    product_name: product?.productName,
    price: product?.fairAppPrice,
    category: product?.productCategory?.parent_category.name,
    sub_category: product?.productCategory?.name,
    quantity: product?.quantity ?? 1,
  });
}

/**
 * Track user signup event DONE
 */
export function trackSignUp(user) {
  track('sign_up', {
    user_id: user?.userID,
    email: user?.email,
    phone_number: user?.phoneNumber,
    method: user?.method || 'email',
  });
}

/**
 * Track when user abandons the cart DONE
 */
export function trackCartAbandoned(cart) {
  track('cart_abandoned', {
    // cart_id: cart.id,
    user_id: cart?.userId || null,
    total_items: cart.totalItems, //total number of products in cart
    total_price: cart.totalValue, // total price of all products
    abandoned_at: new Date().toISOString(),
    products: cart.items.map((product) => ({
      product_id: product?.productID,
      product_name: product?.productName,
      price: product?.fairAppPrice,
      quantity: product.quantity,
    })),
  });
}

/**
 * Track when a user signs out DONE
 */
export function trackSignOut(userId) {
  track('sign_out', {
    user_id: userId,
    signed_out_at: new Date().toISOString(),
  });
}

/**
 * Track when a product is viewed DONE
 */
export function trackProductViewed(product) {
  track('product_viewed', {
    product_id: product?.productID,
    product_name: product?.productName,
    price: product?.fairAppPrice,
    category: product?.productCategory?.parent_category.name,
    sub_category: product?.productCategory?.name,
  });
}
